import {_utils} from "../../utils/_utils.js";
import {initCardsSlider} from "../../utils/cards-slider.js";

/**
 * About — "Decades of FBO Operations" timeline carousel (TZ section 2):
 * → moves one card forward, ← one back (see utils/cards-slider.js). Gap: 32px mobile, 64px desktop;
 * wide cards (.ab-history--wide, Events) 20px.
 */
export const abHistory = () => {
    return new Promise((resolve) => {
        _utils.initSection('.ab-history', (section) => init(section));
        resolve();
    });
};

const init = (section) => {
    const slider = section.querySelector('.ab-history__slider');
    if (!slider) return;

    const isWide = section.classList.contains('ab-history--wide');

    initCardsSlider(
        slider,
        section.querySelector('.ab-history__nav-btn--prev'),
        section.querySelector('.ab-history__nav-btn--next'),
        {
            spaceBetween: isWide ? 20 : 32,
            breakpoints: {
                // QA: → moves 3 cards at once on desktop (5 cards: no extra short click at the end)
                1025: {spaceBetween: isWide ? 20 : 64, slidesPerGroup: 3},
            },
        }
    );
};
